import React, { useState, useEffect } from 'react'
import { Col, Row, Form } from 'react-bootstrap'
import UtilService from '../../service/utilService'

import './StudentQualified.css'

export default function StudentQualified({ setQualifications, token }) {
  const [ranks, setRanks] = useState([])
  const [secretLevels, setSecretLevels] = useState([])
  const [eclEnable, setEclEnable] = useState(false)
  const [eclScore, setEclScore] = useState()
  const [rankEnable, setRankEnable] = useState(false)
  const [rankStart, setRankStart] = useState('23')
  const [rankEnd, setRankEnd] = useState('23')
  const [ageEnable, setAgeEnable] = useState(false)
  const [maxAge, setMaxAge] = useState()
  const [genderEnable, setGenderEnable] = useState(false)
  const [gender, setGender] = useState('M')
  const [scoreCurrentAprEnable, setScoreCurrentAprEnable] = useState(false)
  const [scoreCurrentApr, setScoreCurrentApr] = useState()
  const [scoreCurrentOctEnable, setScoreCurrentOctEnable] = useState(false)
  const [scoreCurrentOct, setScoreCurrentOct] = useState()
  const [secretLevelEnable, setSecretLevelEnable] = useState(false)
  const [secretLevel, setSecretLevel] = useState('1')
  const [rankYearEnable, setRankYearEnable] = useState(false)
  const [minRankYear, setMinRankYear] = useState()
  const [healthEnable, setHealthEnable] = useState(false)
  const [sosEnable, setSosEnable] = useState(false)
  const [minYearSos, setMinYearSos] = useState()

  useEffect(async () => {
    const utilService = new UtilService()
    const rankRes = await utilService.getRank(token)
    const secretLevelRes = await utilService.getSecretLevel(token)
    if (rankRes?.length >= 0) setRanks(rankRes)
    if (secretLevelRes?.length >= 0) setSecretLevels(secretLevelRes)
  }, [])

  useEffect(() => {
    const qualification = []
    if (eclEnable) {
      qualification.push({ type: 'ecl', score: eclScore })
    }
    if (rankEnable) {
      qualification.push({ type: 'rank', start: rankStart, end: rankEnd })
    }
    if (ageEnable) {
      qualification.push({ type: 'age', max: maxAge })
    }
    if (secretLevelEnable) {
      qualification.push({ type: 'secretLevel', level: secretLevel })
    }
    if (genderEnable) {
      qualification.push({ type: 'gender', only: gender })
    }
    if (scoreCurrentAprEnable) {
      qualification.push({ type: 'scoreCurrentApr', score: scoreCurrentApr })
    }
    if (scoreCurrentOctEnable) {
      qualification.push({ type: 'scoreCurrentOct', score: scoreCurrentOct })
    }
    if (rankYearEnable) {
      qualification.push({ type: 'rankYear', min: minRankYear })
    }
    if (healthEnable) {
      qualification.push({ type: 'health', validate: true })
    }
    if (sosEnable) {
      qualification.push({ type: 'sosYear', min: minYearSos })
    }
    setQualifications(qualification)
  }, [
    eclEnable,
    eclScore,
    rankEnable,
    rankStart,
    rankEnd,
    ageEnable,
    maxAge,
    secretLevelEnable,
    secretLevel,
    genderEnable,
    gender,
    scoreCurrentAprEnable,
    scoreCurrentApr,
    scoreCurrentOctEnable,
    scoreCurrentOct,
    rankYearEnable,
    minRankYear,
    healthEnable,
    sosEnable,
    minYearSos,
  ])

  return (
    <>
      <div className='qualification-container'>
        <Row className='qualification-row'>
          <Col md={4}>
            <Form.Group as={Col}>
              <Form.Label>คะแนนภาษาอังกฤษ</Form.Label>
              <Form.Check
                type='checkbox'
                id={`default`}
                onChange={(e) => setEclEnable(e.target.checked)}
              />
            </Form.Group>
          </Col>
          <Col md={8}>
            <Form.Group as={Col}>
              <Form.Label>คะแนนขั้นต่ำ</Form.Label>
              <Form.Control
                type='number'
                min='20'
                max='100'
                required={eclEnable}
                disabled={!eclEnable}
                onChange={(e) => setEclScore(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='qualification-row'>
          <Col md={4}>
            <Form.Group as={Col}>
              <Form.Label>อายุ</Form.Label>
              <Form.Check
                type='checkbox'
                id={`default`}
                onChange={(e) => setAgeEnable(e.target.checked)}
              />
            </Form.Group>
          </Col>
          <Col md={8}>
            <Form.Group as={Col}>
              <Form.Label>อายุไม่เกิน(นับถึงปีเข้ารับการศึกษา)</Form.Label>
              <Form.Control
                type='number'
                min='20'
                max='100'
                required={ageEnable}
                disabled={!ageEnable}
                onChange={(e) => setMaxAge(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='qualification-row'>
          <Col md={4}>
            <Form.Group as={Col}>
              <Form.Label>ชั้นยศ</Form.Label>
              <Form.Check
                type='checkbox'
                id={`default`}
                onChange={(e) => setRankEnable(e.target.checked)}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group as={Col}>
              <Form.Label>ตั้งแต่ชั้นยศ</Form.Label>
              <Form.Control
                as='select'
                value={rankStart}
                onChange={(e) => {
                  setRankStart(e.target.value)
                }}
                required={rankEnable}
                disabled={!rankEnable}>
                {ranks.map((rank, index) => (
                  <option value={rank.no}>{rank.name}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group as={Col}>
              <Form.Label>ถึงชั้นยศ</Form.Label>
              <Form.Control
                as='select'
                value={rankEnd}
                onChange={(e) => {
                  setRankEnd(e.target.value)
                }}
                required={rankEnable}
                disabled={!rankEnable}>
                {ranks.map((rank, index) => (
                  <option value={rank.no}>{rank.name}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
        <Row className='qualification-row' style={{ display: 'none' }}>
          <Col md={2}>
            <Form.Group as={Col}>
              <Form.Label>การเข้าถึงชั้นความลับ</Form.Label>
              <Form.Check
                type='checkbox'
                id={`default`}
                onChange={(e) => setSecretLevelEnable(e.target.checked)}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group as={Col}>
              <Form.Label>ชั้นความลับ</Form.Label>
              <Form.Control
                as='select'
                value={secretLevel}
                onChange={(e) => {
                  setSecretLevel(e.target.value)
                }}
                required={secretLevelEnable}
                disabled={!secretLevelEnable}>
                {secretLevels.map((secretLevel, index) => (
                  <option value={secretLevel.no}>{secretLevel.name}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
        <Row className='qualification-row'>
          <Col md={4}>
            <Form.Group as={Col}>
              <Form.Label>เพศ</Form.Label>
              <Form.Check
                type='checkbox'
                id={`default`}
                onChange={(e) => setGenderEnable(e.target.checked)}
              />
            </Form.Group>
          </Col>
          <Col md={8}>
            <Form.Group as={Col}>
              <Form.Label>เฉพาะ</Form.Label>
              <Form.Control
                as='select'
                value={gender}
                onChange={(e) => {
                  setGender(e.target.value)
                }}
                required={genderEnable}
                disabled={!genderEnable}>
                <option value='M'>ชาย</option>
                <option value='F'>หญิง</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
        <Row className='qualification-row'>
          <Col md={4}>
            <Form.Group as={Col}>
              <Form.Label>คะแนนประเมิน รอบ เม.ย.</Form.Label>
              <Form.Check
                type='checkbox'
                id={`default`}
                onChange={(e) => setScoreCurrentAprEnable(e.target.checked)}
              />
            </Form.Group>
          </Col>
          <Col md={8}>
            <Form.Group as={Col}>
              <Form.Label>คะแนนขั้นต่ำ</Form.Label>
              <Form.Control
                type='number'
                min='20'
                max='100'
                required={scoreCurrentAprEnable}
                disabled={!scoreCurrentAprEnable}
                onChange={(e) => setScoreCurrentApr(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='qualification-row'>
          <Col md={4}>
            <Form.Group as={Col}>
              <Form.Label>คะแนนประเมิน รอบ ต.ค.</Form.Label>
              <Form.Check
                type='checkbox'
                id={`default`}
                onChange={(e) => setScoreCurrentOctEnable(e.target.checked)}
              />
            </Form.Group>
          </Col>
          <Col md={8}>
            <Form.Group as={Col}>
              <Form.Label>คะแนนขั้นต่ำ</Form.Label>
              <Form.Control
                type='number'
                min='20'
                max='100'
                required={scoreCurrentOctEnable}
                disabled={!scoreCurrentOctEnable}
                onChange={(e) => setScoreCurrentOct(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='qualification-row'>
          <Col md={4}>
            <Form.Group as={Col}>
              <Form.Label>ระยะเวลาการครองยศ</Form.Label>
              <Form.Check
                type='checkbox'
                id={`default`}
                onChange={(e) => setRankYearEnable(e.target.checked)}
              />
            </Form.Group>
          </Col>
          <Col md={8}>
            <Form.Group as={Col}>
              <Form.Label>
                นับถึง 1 ต.ค.ปีเข้ารับการศึกษา ไม่น้อยกว่า (ปี)
              </Form.Label>
              <Form.Control
                type='number'
                max='40'
                required={rankYearEnable}
                disabled={!rankYearEnable}
                onChange={(e) => setMinRankYear(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='qualification-row'>
          <Col md={4}>
            <Form.Group as={Col}>
              <Form.Label>ผลตรวจร่างกาย</Form.Label>
              <Form.Check
                type='checkbox'
                id={`default`}
                onChange={(e) => setHealthEnable(e.target.checked)}
              />
            </Form.Group>
          </Col>
          <Col md={8}>
            <Form.Group as={Col}>
              <Form.Label></Form.Label>
              <Form.Control value='ผ่าน' disabled={true} />
            </Form.Group>
          </Col>
        </Row>
        <Row className='qualification-row'>
          <Col md={4}>
            <Form.Group as={Col}>
              <Form.Label>ปีจบ นฝ.</Form.Label>
              <Form.Check
                type='checkbox'
                id={`default`}
                onChange={(e) => setSosEnable(e.target.checked)}
              />
            </Form.Group>
          </Col>
          <Col md={8}>
            <Form.Group as={Col}>
              <Form.Label>ไม่ต่ำกว่า(ปี)</Form.Label>
              <Form.Control
                type='number'
                max='40'
                required={sosEnable}
                disabled={!sosEnable}
                onChange={(e) => setMinYearSos(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
      </div>
    </>
  )
}
